var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSabanaDescarga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.344,
    height: 25.74,
    viewBox: "0 0 23.344 25.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ilustraci\\xF3n_8",
    "data-name": "Ilustraci\\xF3n 8",
    transform: "translate(11.032 12.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57359",
    "data-name": "Grupo 57359",
    transform: "translate(-11.032 -12.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57358",
    "data-name": "Grupo 57358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25568",
    "data-name": "Trazado 25568",
    d: "M23.344,6.7V6.646A.9.9,0,0,0,23.076,6L17.286.266h0l0,0c-.012-.012-.026-.021-.04-.033a.963.963,0,0,0-.094-.077l0,0c-.02-.014-.043-.022-.063-.034S17.024.083,16.993.07l0,0C16.961.056,16.933.051,16.9.041s-.052-.018-.08-.023h0A.929.929,0,0,0,16.668,0l-.023,0H4.579a.906.906,0,0,0-.906.907V3.852H.907A.906.906,0,0,0,0,4.758v11.3a.907.907,0,0,0,.907.907H3.674v7.873a.906.906,0,0,0,.906.907h17.86a.906.906,0,0,0,.906-.907V6.7ZM17.552,3.094l2.7,2.7h-2.7ZM1.812,5.665h9.865v9.482H1.812ZM18.155,12.14v3.007H14.439V12.14ZM8.911,19.947V16.96h3.716v2.987Zm5.528-2.987h3.716v2.987H14.439ZM5.486,23.927V16.96H7.1v3.894A.905.905,0,0,0,8,21.76H19.061a.906.906,0,0,0,.907-.906V11.233a.906.906,0,0,0-.907-.906H13.736a.922.922,0,0,0-.2-.025c-.014,0-.028,0-.042,0V4.758a.905.905,0,0,0-.906-.906h-7.1V1.812H15.739V6.7a.905.905,0,0,0,.906.906h4.887V23.927Z",
    fill: "#a867ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25569",
    "data-name": "Trazado 25569",
    d: "M8.192,12.81a.906.906,0,0,0,1.28-1.283L7.986,10.043,9.465,8.56A.906.906,0,0,0,8.182,7.28L6.7,8.762,5.216,7.279a.906.906,0,1,0-1.28,1.283l1.487,1.483L3.943,11.529a.906.906,0,0,0,1.283,1.28l1.479-1.483Z",
    transform: "translate(0.213 0.407)",
    fill: "#a867ee"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabanaDescarga);
export default __webpack_public_path__ + "static/media/sabana_descarga.f5ec7f8f5bdba1ab62e1254137962547.svg";
export { ForwardRef as ReactComponent };